import { rgba } from "polished";
import React, { useMemo } from "react";
import styled from "styled-components";

import { HexTooltip } from "../../hex-components";
import { useOnClickProps } from "../../hooks/useOnClickProps";
import { ORG_ID } from "../../orgs";
import { Routes } from "../../route/routes";
import { useProjectContext } from "../../util/projectContext";

const Wrapper = styled.div`
  margin-left: auto;

  color: ${({ theme }) => rgba(theme.userActionColor, 0.7)};
  font-size: ${({ theme }) => theme.fontSize.SMALL};

  cursor: default;
`;

interface AppCommentIndicatorProps {
  readonly commentEntityId: string;
}

export const AppCommentIndicator: React.ComponentType<AppCommentIndicatorProps> =
  React.memo(function AppCommentIndicator({ commentEntityId }) {
    const { hexId, version } = useProjectContext();

    const appLink = useMemo(() => {
      return Routes.APP.getUrl({
        hexId,
        version,
        urlParams: {
          selectedStaticCellId: commentEntityId,
        },
      });
    }, [commentEntityId, hexId, version]);

    const linkInAppClickProps = useOnClickProps({
      to: `${window.location.origin}/${ORG_ID}${appLink}`,
      target: "_blank",
    });

    return (
      <Wrapper>
        <HexTooltip
          content={
            <div>
              This comment was added from a published app.{" "}
              <a {...linkInAppClickProps}>View in app</a>
            </div>
          }
          hoverCloseDelay={100}
          interactionKind="hover"
        >
          In-app
        </HexTooltip>
      </Wrapper>
    );
  });
